import { toast } from "@/components/ui/";
import { getRouteApi } from "@tanstack/react-router";
import { GoogleButton } from "./components/GoogleButton";
import { useGoogleLogin } from "./network/useGoogleLogin";

export const GoogleLoginForm = () => {
  const routeApi = getRouteApi("/login");
  const { redirect } = routeApi.useSearch();
  const { mutate: googleLogin } = useGoogleLogin(redirect || "/");

  const handleGoogleSuccess = (token: string) => {
    googleLogin(
      { token },
      {
        onError: () => {
          toast.error("Failed to authenticate with Google. Please try again.");
        },
      },
    );
  };

  const handleGoogleError = (error?: string) => {
    toast.error(
      `Google login failed. Please try again.${error ? ` Error: ${error}` : ""}`,
    );
  };

  return (
    <GoogleButton onSuccess={handleGoogleSuccess} onError={handleGoogleError} />
  );
};
